import { getChartResult, getFinancialData } from 'serviceWorker/services/analytics';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { analyticsContract } from 'shared/domain/analytics/analyticsContract';
import { runWhenRequestsAllowed } from './runWhenRequestsAllowed';

/** Answers chart and financial data requests of the page. */
export function serveAnalyticsRequests(): ChannelUnsubscribe {
  return channelServer.handle(analyticsContract, {
    getChart: getChartResult,
    // Held during a project switch like the legacy `SYNC`, rejected instead of dropped.
    getFinancialData: () => runWhenRequestsAllowed(getFinancialData),
  });
}
